import React from "react"
import {useSubscription} from "@apollo/client"
import ProgressBar from "react-bootstrap/ProgressBar"

import JOB_SUBSCRIPTION from "graphql/Transcode/Job/subscription/jobUpdate"
import {BackofficePage, BackofficePanel} from "components/backoffice/Layout/BackofficePage"

export const JobStatus = (props: any) => {
  const {data} = useSubscription(JOB_SUBSCRIPTION)
  const progress = data?.jobUpdate?.progress || 0
  const isJobDone = data?.jobUpdate?.status === "DONE"
  const isJobFailed = data?.jobUpdate?.status === "ERROR"
  const isInProgress = data?.jobUpdate?.status === "RUNNING"
  const variant = isJobDone ? "success" : isJobFailed ? "danger" : "info"

  return <BackofficePage eyebrow="Centre de traitement" title="État du job" description="Suivez cette tâche de transcodage en temps réel." icon="fa-microchip">
    <BackofficePanel title="Progression" description={isJobDone ? "Traitement terminé" : isJobFailed ? "Une erreur est survenue" : "Traitement en cours"} icon="fa-wave-square">
      <div className="standalone-job-progress">
        <strong>{progress}<small>%</small></strong>
        <ProgressBar animated={isInProgress} variant={variant} now={progress} />
        <span>{isJobDone ? "Le fichier est prêt." : isJobFailed ? "Consultez les journaux pour identifier le problème." : "Zipflix prépare le média…"}</span>
      </div>
    </BackofficePanel>
  </BackofficePage>
}
